import React from 'react';
import './TeamMembersTableSkeleton.css';

const SKELETON_ROWS = Array.from({ length: 4 }, (_, i) => i);

const TeamMembersTableSkeleton: React.FC = () => (
  <div className="meview-tm-skeleton">
    <div className="team-members-table">
      <div className="table-header-tm">
        <div className="header-cell user-cell">
          <span>Team Members</span>
          <span className="members-count">(...)</span>
        </div>
        <div className="header-cell progress-cell">Progress</div>
        <div className="header-cell story-points-cell">Story Points</div>
        <div className="header-cell completed-tasks-cell">Completed Tasks</div>
        <div className="header-cell rework-cell">Rework</div>
        <div className="header-cell working-capacity-cell">Actual Capacity</div>
        <div className="header-cell logged-hours-cell">Logged Hours</div>
        <div className="header-cell estimated-cell">Estimated</div>
        <div className="header-cell remaining-cell">Remaining</div>
        <div className="header-cell timepersp-cell">Time Per SP</div>
        <div className="header-cell efficiency-cell">Efficiency</div>
      </div>

      <div className="table-body-vm">
        {SKELETON_ROWS.map((_, index) => (
          <div key={index} className="table-row-vm skeleton-row">
            <div className="table-cell user-cell">
              <div className="user-info">
                <div className="skeleton-avatar" />
                <div className="user-details-vm">
                  <div className="skeleton-text skeleton-name" />
                </div>
              </div>
            </div>
            <div className="table-cell story-points-cell">
              <div className="progress-container-sk">
                <div className="skeleton-progress-bar">
                  <div className="skeleton-progress-fill" />
                </div>
              </div>
            </div>
            <div className="table-cell story-points-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell completed-tasks-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell rework-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell working-capacity-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell logged-hours-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell estimated-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell remaining-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell timepersp-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
            <div className="table-cell efficiency-cell">
              <div className="skeleton-text skeleton-small" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default TeamMembersTableSkeleton;
